import { BsPersonLinesFill } from 'react-icons/bs'
import { HiUserGroup } from 'react-icons/hi'

export const contactHeaderItems = {
  linkButtons: [
    {
      urlPath: 'contactGroup',
      IconComponent: HiUserGroup,
      text: 'グループ',
    },
    {
      urlPath: 'contactAddress',
      IconComponent: BsPersonLinesFill,
      text: '連絡先',
    },
  ],
}
